import React, { useEffect, useState } from "react";
import { Building2 } from "lucide-react";
import TopCompanies from "./TopCompanies.jsx";
import CompaniesBrowser from "./CompaniesBrowser.jsx";
import { API_URL } from "../utils/config.js";

const exOf = (e) => {
  const s = String(e || "").toUpperCase();
  if (s.includes("NASDAQ")) return "NASDAQ";
  if (s.includes("ARCA") || s.includes("AMERICAN") || s.includes("MKT") || s.includes("AMEX")) return "AMEX";
  if (s.includes("NYSE")) return "NYSE";
  if (s.includes("CBOE") || s.includes("BATS")) return "CBOE";
  return "";
};
const tvSym = (c) => {
  const ex = exOf(c.exchange);
  const t = String(c.ticker).replace(/-/g, ".");
  return ex ? ex + ":" + t : t;
};

export default function Companies({ user }) {
  const [sector, setSector] = useState("all");
  const [top, setTop] = useState([]);

  useEffect(() => {
    let off = false;
    const u = API_URL + "/market/top?limit=10" + (sector !== "all" ? "&sector=" + encodeURIComponent(sector) : "");
    fetch(u).then((r) => (r.ok ? r.json() : Promise.reject()))
      .then((rows) => { if (!off) setTop(rows.map((c) => ({ ...c, symbol: tvSym(c) }))); })
      .catch(() => { if (!off) setTop([]); });
    return () => { off = true; };
  }, [sector]);

  return (
    <main className="page-bg">
      <div className="dash-main-content">
        <div className="top-bar">
          <div className="watchlist-title">
            <Building2 size={18} />
            <span>Companies</span>
          </div>
        </div>
        <p className="text-muted mb-3">
          {user ? "Browse every listed US company by sector." : "Browse every listed US company by sector. Sign up to follow them and personalize your experience."}
        </p>
        <TopCompanies
          title={sector === "all" ? "Top 10 companies by market cap" : "Top 10 in " + sector}
          companies={top}
          limit={10}
          scroll
        />
        <CompaniesBrowser sector={sector} onSector={setSector} />
      </div>
    </main>
  );
}